import {Switch} from '@wandb/weave/components';
import React, {useState} from 'react';

import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsDrawerContext} from '../MediaSettingsDrawerContextProvider';

export const SnapToExistingStep = () => {
  const {config, updateConfig, unsetConfigField} =
    useMediaSettingsDrawerContext();
  const [isChecked, setIsChecked] = useState(config.snapToExistingStep);
  return (
    <div className="flex items-center justify-between">
      <SettingTitle
        title="Snap to step"
        description="Align media display with a specific run for comparison"
        configField="snapToExistingStep"
        unsetConfigField={() => unsetConfigField('snapToExistingStep')}
      />
      <Switch.Root
        data-test="snap-to-existing-step-checkbox"
        checked={isChecked}
        onCheckedChange={newValue => {
          setIsChecked(newValue);
          updateConfig({snapToExistingStep: newValue});
        }}>
        <Switch.Thumb checked={isChecked} />
      </Switch.Root>
    </div>
  );
};
